'use strict';

class ReadonlyIf {
  constructor() {
    'ngInject';

    this.restrict = 'A';
    this.scope = {readonlyIf: '='};
  }

  link(scope, element) {
    scope.$watch(() => {
      if (!scope.readonlyIf) {
        return;
      }

      angular.forEach(element.find('input'), (value) => {
        let inputElement = angular.element(value);
        inputElement.attr('readonly', 'readonly');
        inputElement.attr('disabled', true);
      });

      angular.forEach(element.find('md-radio-button'), (value) => {
        let radioElement = angular.element(value);
        radioElement.attr('disabled', 'disabled');
      });

      angular.forEach(element.find('md-select'), (value) => {
        let selectElement = angular.element(value);
        selectElement.attr('disabled', 'disabled');
      });

      angular.forEach(element.find('md-option'), (value) => {
        let optionElement = angular.element(value);
        optionElement.attr('disabled', 'disabled');
      });

      angular.forEach(element.find('select'), (value) => {
        let selectElement = angular.element(value);
        selectElement.attr('disabled', 'disabled');
      });

      angular.forEach(element.find('option'), (value) => {
        let optionElement = angular.element(value);
        optionElement.attr('disabled', 'disabled');
      });
    });
  }
}

export default angular.module('leptonApp.ReadonlyIf', [])
  .directive('readonlyIf', [() => new ReadonlyIf()])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/readonly_if/readonly_if.directive.js